import React from 'react';
import { Text } from 'components';
import './SideMenu.style.css';
import { useNavigate, useLocation } from 'react-router-dom';

const SideMenuItem = ({ title, children }) => {
  const navigate = useNavigate();
  const location = useLocation(); // 현재 경로를 가져옴

  return (
    <div className="side_menu_item_layout">
      <h4>{title}</h4>
      <ul>
        {children.map((_item, _index) => (
          <li
            key={`sub_menu_${_index}`}
            onClick={() => navigate(_item.path)}
            className={
              location.pathname === _item.path ? 'active-menu-item' : ''
            }
          >
            {_item.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

const SideMenu = ({ menu, title }) => {
  // 기본 메뉴 데이터 설정
  const defaultMenu = [
    {
      title: '나의 쇼핑정보',
      children: [
        {
          title: '주문/배송조회',
          path: '/mypage/order',
        },
        {
          title: '취소/교환/반품 내역',
          path: '/mypage/cancel',
        },
        {
          title: '정기배송 설정 관리',
          path: '/mypage/subscribe',
        },
      ],
    },
    {
      title: '나의 혜택',
      children: [
        {
          title: '회원 등급',
          path: '/cs/notice/hZsTD8bG3Kn2XCUKxyL1Ow%3D%3D',
        },
        {
          title: '포인트',
          path: '/mypage/point',
        },
        {
          title: '쿠폰',
          path: '/mypage/coupon',
        },
      ],
    },
    {
      title: '나의 활동',
      children: [
        {
          title: '위시리스트',
          path: '/mypage/wishlist/wishlist',
        },
        // {
        //   title: '최근 본 상품',
        //   path: '/mypage/wishlist/recentlysaw',
        // },
        {
          title: '장바구니',
          path: '/order/cart',
        },
        // {
        //   title: '이벤트 참여 내역',
        //   path: '/mypage/event',
        // },
        {
          title: '상품 리뷰',
          path: '/mypage/review',
        },
        {
          title: '상품 문의',
          path: '/mypage/qna',
        },
        {
          title: '1:1 문의',
          path: '/cs/inquire',
        },
        {
          title: '선물내역',
          path: '/mypage/presents',
        },
        // {
        //   title: '재입고 알림 신청 내역',
        //   path: '/mypage/restock',
        // },
      ],
    },
    {
      title: '나의 정보관리',
      children: [
        {
          title: '회원 정보 수정',
          path: '/mypage/editprofile',
        },
        {
          title: 'JM Pay 관리',
          path: '/mypage/pay',
        },
        {
          title: '배송지 관리',
          path: '/mypage/address',
        },
      ],
    },
  ];

  // props로 전달된 menu가 없으면 기본 메뉴를 사용
  const currentMenu = menu || defaultMenu;

  return (
    <div>
      <Text
        className={'side_menu_title'}
        size={32}
        weight={700}
        color={'var(--black-color)'}
        style={{
          borderBottom: '2px solid var(--black-color)',
          paddingBottom: 24,
        }}
      >
        {title || '마이페이지'}
      </Text>
      {currentMenu.map((_item, _index) => (
        <SideMenuItem
          key={`menu_${_index}`}
          title={_item.title}
          children={_item.children || []}
        />
      ))}
    </div>
  );
};

export default SideMenu;
